import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "@nuxtjs/composition-api";

import { useAmplitude, useTranslate, useVuetify } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'Hero',
  setup(__props) {

const vuetify = useVuetify();
const amplitude = useAmplitude();

const trackOpenStore = (store: string) => {
  amplitude?.sendDownloadAppEvent("homepage-module", store);
};

const isLoading = ref(true);

const { t } = useTranslate();

const videoLabel = t(
  "Diverse and stylish fashion and lifestyle Creators alongside a phone screen displaying the Watch Tab of the LTK app.",
);

const videoElement = ref<HTMLVideoElement | null>(null);

const videoSize = computed(() => {
  if (vuetify.breakpoint.xlOnly) {
    return "xl";
  } else if (vuetify.breakpoint.lgOnly || vuetify.breakpoint.smOnly) {
    return "lg";
  } else if (vuetify.breakpoint.xsOnly || vuetify.breakpoint.mdOnly) {
    return "md";
  }
});

const videoWebmSrc = computed(() => `/videos/home/hero/webm/${videoSize.value}.webm`);
const videoMp4Src = computed(() => `/videos/home/hero/fallback/${videoSize.value}.mp4`);

// Swap the video source when the viewport size changes
watch([videoSize], function setVideoPlayback() {
  const video = videoElement.value;

  if (!video) {
    return;
  }

  video.load();
  video.currentTime = 0;

  if (!video.paused) {
    video.play().catch((e) => console.error("Video playback failed:", e));
  }
});

return { __sfc: true,vuetify, amplitude, trackOpenStore, isLoading, t, videoLabel, videoElement, videoSize, videoWebmSrc, videoMp4Src }
}

})